import React from 'react';
import styles from './SupportedDevices.module.css';

const SupportedDevices = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Supported devices and browsers</h2>
      <p className={styles.description}>
        The ToxBox AI platform is designed to be accessible and functional across a wide range of devices, ensuring flexibility for users whether they are working from an office, remotely, or on the go.
      </p>

      <div className={styles.section}>
        <h3>1. Desktop & Laptop Computers</h3>
        <p>Operating Systems:</p>
        <ul className={styles.list}>
          <li>Windows 10 and 11</li>
          <li>macOS</li>
        </ul>
        <p>These platforms offer the full-featured experience, ideal for configuring call flows, monitoring analytics, and managing AI agents.</p>
      </div>

      <div className={styles.section}>
        <h3>2. Mobile Devices</h3>
        <ul className={styles.list}>
          <li>Smartphones and Tablets:</li>
          <li>Android</li>
          <li>iOS</li>
        </ul>
        <p>Users can manage call logs, receive call alerts, and interact with essential dashboard features via mobile browsers or dedicated apps (if available).</p>
      </div>

      <div className={styles.section}>
        <h3>Supported Web Browsers</h3>
        <p>
          To ensure smooth operation of audio features, real-time communication, and dashboard functionality, ToxBox supports the following major web browsers:
        </p>

        <strong>Google Chrome (Latest versions)</strong>
        <ul className={styles.list}>
          <li>Fast, secure, and most compatible with real-time audio APIs like WebRTC.</li>
          <li>Preferred for both dashboard access and agent interfaces.</li>
        </ul>

        <strong>Microsoft Edge</strong>
        <ul className={styles.list}>
          <li>Chromium-based and supports all necessary features for voice interaction and dashboard performance.</li>
        </ul>
      </div>
    </div>
  );
};

export default SupportedDevices;
